
<div class="col-xs-12 pb-3 flex">
  <select class="mR15" [required]="required" name="{{prefix ? prefix + '_' : ''}}{{name}}" [(ngModel)]="parseValue" [ngClass]="{ 'bg-light': !parseValue}" (change)="addCannedResponse()">
    <option value="" selected="" hidden="">Select-Canned-Response</option>
    <option *ngFor="let option of options;" [value]="option.value">{{option.display}}</option>
  </select>
  <mat-select class="col-xs-9 mr-15 pb-1" [(ngModel)]="selectedTags" name="selectedTags" placeholder="Select Tag(s)" [formControl]="formController" style="min-width:150px;padding:6px;outline:1px solid grey;" multiple="multiple">
    <mat-option *ngFor="let item of appConfig.Shared.CannedResponse.PossibleTags" [value]="item">{{item}}</mat-option>
  </mat-select>
</div>